define.alias("shared/types", "calendar/types/index");